import { render } from "./Schlafberatung.vue?vue&type=template&id=74e0d782&scoped=true"
import script from "./Schlafberatung.vue?vue&type=script&lang=js"
export * from "./Schlafberatung.vue?vue&type=script&lang=js"

import "./Schlafberatung.vue?vue&type=style&index=0&id=74e0d782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e0d782"]])

export default __exports__